import { EActionType } from '@/frontend/src/types/context';
import type { IState, TAction } from '@/frontend/src/types/context';

export const reducer = (state: IState, action: TAction): IState => {
    const { type } = action;

    // eslint-disable-next-line sonarjs/no-small-switch
    switch (type) {
        case EActionType.SetAddressAutocompleteError:
            return {
                ...state,
                addressAutocompleteError: action.payload,
            };
        case EActionType.SetActiveView:
            return {
                ...state,
                activeView: action.payload,
            };
        case EActionType.SetLocationResult:
            return {
                ...state,
                locationResult: action.payload,
            };
        case EActionType.SetClosestLocationResult:
            return {
                ...state,
                closestLocationResult: action.payload,
            };
        case EActionType.SetShouldDisplayHouseNumber:
            return {
                ...state,
                shouldDisplayHouseNumber: !!action.payload,
            };
        case EActionType.SetIsInvalidAddress:
            return {
                ...state,
                isInvalidAddress: !!action.payload,
            };
        default:
            return state;
    }
};
